import ModeloList from './ModeloList'
export {ModeloList}
export default ModeloList
